import type { ApiLogger } from '@hetivo/hetivo-lib-types';

/**
 * Create a console-based API logger.
 * In development mode, logs requests and responses at the debug level.
 * Errors are always logged regardless of mode.
 *
 * @param isDev - Whether the app is running in development mode (controls debug-level logging)
 */
export function createApiLogger(isDev: boolean): ApiLogger {
  return {
    onError: (method, url, status, durationMs, error): void => {
      console.error(
        `[API] ${method.toUpperCase()} ${url} -> ${status ?? 'NETWORK_ERROR'} (${Math.round(durationMs)}ms)`,
        error,
      );
    },
    onRequest: (method, url): void => {
      if (isDev) console.debug(`[API] ${method.toUpperCase()} ${url}`);
    },
    onResponse: (method, url, status, durationMs): void => {
      if (isDev) console.debug(`[API] ${method.toUpperCase()} ${url} -> ${status} (${Math.round(durationMs)}ms)`);
    },
  };
}
